

import React from 'react';
import { connect } from 'react-redux';
import LoadingAnimation from '../../../Utils/loadingAnimation.js';
import Network from '../../../Utils/network.js';
import { setRegisterDetails, setCurrentPage, setOrderDetails } from '../../../General/Actions';
import NoDataFound from '../../../Utils/noDataFound.js';
import PlanCartComponent from './UpgradeOfferCartComponent';
import moment from 'moment';
import { FiWifi } from "react-icons/fi";
import MyAccountComponent from '../MyAccountComponent';
import { Button } from 'reactstrap';
import GeneralUtils from '../../../Utils/generalUtils.js';
import PathIcon from '../../../ImageAssets/pathIcon.png';
import Constants from '../../../Utils/constants.json';
import PhoneDisabled from '../../../ImageAssets/phoneCallDisabled.png';
import TVDisabled from '../../../ImageAssets/TVNewDisabled.png';
import SliderModal from '../../../Utils/sliderModal.js';
//import searchIcon from '../../../ImageAssets/searchIcon.svg'

class UpgradeOfferComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            allDeviceDetails: [],
            allOfferDetails: [],
            allComparisonResults: [],
            retainableArray: [],
            isAlreadySelected: false,
            offerArray: [],
            devicesArray: [],
            customizeDetails: {
                devices: [],
                addons: [],
                returnDevice: [],
                showCustomizeButton: false
            },
            compatibleDevicesArray: [],
            nonCompatibleDevicesArray: [],
            equipmentType :"",
            currentPlanId: "",
            activeAddonIds: "",
            redirectToMyAccount: false,
            feature: "",
            serviceDetails: {},
            isCartVisibleForMobile: false,
            selectedContract: {},
            isMoreInfoModalOpen: false,
            content: [],
            heading: "NA",
            moreInfo_name: "",
            transportType: "",
            ignorePlanIds: []
        }
    }

    componentDidMount() {
        this.updateWindowDimensions();
        window.scroll({ top: 0, left: 0, behavior: 'smooth' });
        this.props.setRegisterDetails("isConfirmationReached", false);
        this.getAllAddonIds();
        this.initializeServiceListFromCache(this.props.cache.subscriberInfo);
        var headers = {};
        
        headers["CustomerType"] = this.props.userDetails.customerType;
        headers["CustomerCategory"] = this.props.userDetails.customerCategory;
        headers["CustomerSubCategory"] = this.props.userDetails.customerSubCategory;
        headers["Channel"] = this.props.locales.channelIdForSCM;
        headers["CONNECTIONTYPE"] = this.props.cache.currentPlanDetails.connectionType;
        if(this.state.transportType !== ""){
            headers["TransportType"]= this.state.transportType
        }
        window.addEventListener('resize', this.updateWindowDimensions);
        window.addEventListener('scroll', this.handleScroll);
                var dataToSendForAddon = {
                    "offerId":  this.state.currentPlanId,
                    "pog":  this.props.registerDetails.givenAddress.pog,            
                    "header": headers
                }
                //delete headers.ONTAvailable
                Network.executeAxios("fetchOffers", "POST", dataToSendForAddon, (response) => {
                if (response && response[0]) {
                    for (var x = 0; x < response.length; x++) {
                        var currentObj = response[x].success;
                        for(var k=0; k< currentObj.length; k++){
                            this.state.offerArray.push(currentObj[k]);
                        }
                       
                    }
                }

                    if (Object.keys(this.props.registerDetails.offers).length == 0) {

                    } else {
                        this.setState({ serviceDetails: this.props.registerDetails.offers })
                    }

                    if (Object.keys(this.props.registerDetails.contracts).length == 0) {

                    } else {
                        this.setState({ selectedContract: this.props.registerDetails.contracts })
                    }

                    //this.state.allOfferDetails = this.state.offerArray;
                    this.initializeAllOfferDetails(this.state.offerArray);
                    setTimeout(() => {
                        this.setState({ignorePlanIds: this.props.registerDetails.ignorePlanIds, isLoading: false });
                    }, 1000);
                });
    }

    initializeAllOfferDetails(productOfferingsArrayUpdated){
        for(var e=0; e< productOfferingsArrayUpdated.length; e++){
            var tariffArr = [];
            var bucketDetailsArr = [];
            var currentObj = productOfferingsArrayUpdated[e]
            if(currentObj.ratingParameters && currentObj.ratingParameters[0] && currentObj.ratingParameters[0].meteredRates &&
                currentObj.ratingParameters[0].meteredRates[0]){
                    var currentMeteredRatesObj = currentObj.ratingParameters[0].meteredRates;
                    for(var g=0; g<currentMeteredRatesObj.length; g++){
                        let temp = {
                            "name": currentMeteredRatesObj[g].name
                        }
                        tariffArr.push(temp)
                    }
            }
            if(currentObj.bucketDetails && currentObj.bucketDetails[0]){
                for(var f=0; f< currentObj.bucketDetails.length; f++){
                    var currentBucket = currentObj.bucketDetails[f];
                    if(currentBucket.counter && currentBucket.counter.serviceType && currentBucket.counter && currentBucket.counter.serviceType.name){
                        let temp = {
                            "name": currentBucket.counter.serviceType.name +" - "+ currentBucket.counter.name
                        }
                        bucketDetailsArr.push(temp);
                    }
                }
            }
            currentObj["tariffArr"] = tariffArr;
            currentObj["bucketDetailsArr"] = bucketDetailsArr;
        }
        this.state.allOfferDetails = productOfferingsArrayUpdated;
    }

    tabLinkClicked(type){
        if(type === "manageService"){
            this.setState({feature: "addAddon"})
        }
        this.setState({redirectToMyAccount:true})
    }

    handleInputValueChange(name, event, type) {
        this.state[name]=event;
        this.setState({"dummy":"dummy"})
    };

    getAllAddonIds(){
        var activeAddonIds = [];
        for(var i=0;i<this.props.registerDetails.activeAddons.length; i++){
            activeAddonIds.push(this.props.registerDetails.activeAddons[i].planId)
        }
        this.state.activeAddonIds = activeAddonIds;
    }

    initializeServiceListFromCache(receivedSubscriberInfoResponse) {
        var maBalance = "0";
        var serviceCode = ""
        var serviceName = ""
        var reduxCache = this.props.cache;
        console.log("reduxCache",reduxCache)
        try {
            var receivedResponse = reduxCache.querySubscriberResponse;
            var params = receivedResponse.profile_info.basic_details;
            var finalContactNumber = "";
            var finalEmailId = "";
            var finalFirstName = "";
            var finalLastName = "";
            var finalProfileId = "";
         
            for (var i = 0; i < params.length; i++) {
                if (params[i].id === "first_name") {
                    finalFirstName = params[i].value;
                }
                if (params[i].id === "last_name") {
                    finalLastName = params[i].value;
                }
                if (params[i].id === "contact_number_1") {
                    finalContactNumber = params[i].value;
                }
                if (params[i].id === "contact_email_id") {
                    finalEmailId = params[i].value;
                }
                if (params[i].id === "profile_id") {
                    finalProfileId = params[i].value;
                }
              
            }
            this.state.firstName = finalFirstName
            this.state.lastName = finalLastName
            this.state.contactEmailAddress = finalEmailId
            this.state.contactNumber = finalContactNumber
            this.state.profileId = finalProfileId

        } catch (err) {

        }
        try {
            var serviceParams = receivedSubscriberInfoResponse.service_info.basic_details;
         
            for (var j = 0; j < serviceParams.length; j++) {
                if (serviceParams[j].id === "maBalance") {
                    maBalance = serviceParams[j].value
                }  
                if (serviceParams[j].id === "service_code") {
                    serviceCode = serviceParams[j].value
                }
                if (serviceParams[j].id === "service_name") {
                    serviceName = serviceParams[j].value
                }
                if (serviceParams[j].id === "access_type") {
                    this.state.transportType = serviceParams[j].value
                }  
            }
            this.state.currentPlanId = this.props.cache.currentPlanDetails.planId;

        } catch (err) {

        }
        try{
            var accountData = receivedResponse.account_info.basic_details;
            var accountId = "";
            for (var k = 0; k < accountData.length; k++) {
                if (accountData[k].id === "account_id") {
                    accountId = accountData[k].value;
                }
            }
            this.state.accountId = accountId
        } catch(err){
            accountData=[]
        }

        
        this.setState({
            dummy: "dummy"
        }, () => {
            var contactDetails = {}
            contactDetails["firstName"] = this.state.firstName;
            contactDetails["lastName"] = this.state.lastName;
            contactDetails["contactEmailAddress"] = this.state.contactEmailAddress;
            contactDetails["contactNumber"] = this.state.contactNumber;
            contactDetails["profileId"] = this.state.profileId;
            contactDetails["accountId"] = this.state.accountId;
            contactDetails["currentPlanId"] = this.state.currentPlanId;
            contactDetails["currentPlanName"] = this.props.cache.currentPlanDetails.activePlanName;
            contactDetails["serviceId"] = localStorage.getItem("currentServiceId")
            contactDetails["serviceCode"] = serviceCode;
            contactDetails["serviceName"] = serviceName;
            this.props.setRegisterDetails("confirmation", contactDetails);
            this.props.setRegisterDetails("generalResponse.maBalance",maBalance)
        })

    }

    selectAddonClickedForAddon(receivedData, minCount,allAddonDetail) {
     
        try {
            receivedData = JSON.parse(decodeURIComponent(receivedData))
                if(parseInt(minCount)>0){
                    receivedData["count"] = minCount;
                } else {
                    receivedData["count"] = 1;
                }
            receivedData["showCustomizeButton"] = true;
            this.state.customizeDetails.addons.push(receivedData);
            this.props.setRegisterDetails("offers", this.state.services);
            this.setState({ showCustomizeButton: true });
          
        }
        catch (err) {
            receivedData = []
        }
    }

    moreInfoModalHandler= (dataObject) => {
        if (dataObject.type  === "cancel") {
            this.setState({ isMoreInfoModalOpen: false })
        }
    }

    contractSelectButtonClicked(receivedData,event,currentPackageData){
        event.stopPropagation();
        //receivedData = JSON.parse(decodeURIComponent(receivedData));
        this.state.selectedContractId = receivedData.id;
        var isAlreadySelected = false;
        for (var i = 0; i < Object.keys(this.state.selectedContract).length; i++) {
            if (receivedData["id"] === this.state.selectedContract.id) { isAlreadySelected = true; }
        }
      
        if (isAlreadySelected) {
            this.state.selectedContract = {};
            this.props.setRegisterDetails("contracts", {});
        } else {
            this.state.selectedContract=receivedData;
            this.props.setRegisterDetails("contracts", this.state.selectedContract);
        }

        if(currentPackageData.id === this.state.serviceDetails.id){
            
        } else {
            this.planSelectionButtonClicked(currentPackageData) 
        }

        if(Object.keys(this.state.serviceDetails).length <= 0){
            this.planSelectionButtonClicked(currentPackageData) 
        }
        this.setState({ "dummy": "dummy" })
    }

    planSelectionButtonClicked(receivedData) {
        receivedData = JSON.parse(decodeURIComponent(receivedData));
        this.props.setRegisterDetails("customize.addons", []);
        this.props.setRegisterDetails("customize.devices", []);
        var isAlreadySelected = false;
        for (var i = 0; i < Object.keys(this.state.serviceDetails).length; i++) {
            if (receivedData["id"] == this.state.serviceDetails.id) { isAlreadySelected = true; }
        }
      
        if (isAlreadySelected) {
            this.state.serviceDetails = {};
            this.props.setRegisterDetails("offers", {});
        } else {
            var contracts = receivedData.contractDetails
            for(var x=0; x< contracts.length; x++){
                if(contracts[x].id === this.state.selectedContractId){
                    receivedData["contract_details"] = contracts[x];
                    receivedData["selectedContractId"] = this.state.selectedContractId;
                    delete receivedData.contractDetails;
                }
            }
            this.state.serviceDetails=receivedData;
            this.props.setRegisterDetails("offers", this.state.serviceDetails);
        }

        this.setState({ "dummy": "dummy" })
    }

    removeAddonClickedForAddon(receivedData,allAddonDetail) {
        try {
            var addonIndexToBeRemoved = "";
            var temp = []
            Object.assign(temp, this.state.customizeDetails.addons);
            for (var i = 0; i < temp.length; i++) {
                if (temp[i].id === receivedData) {
                    addonIndexToBeRemoved = i;
                }
            }
            temp.splice(addonIndexToBeRemoved, 1);
            this.state.customizeDetails.addons = temp;
            this.props.setRegisterDetails("customize.addons", this.state.customizeDetails.addons);
            this.state.showCustomizeButton = false;
            this.setState({ "dummy": "dummy" });
        }
        catch (err) {
            receivedData = []
        }
    }

    populateAllOffers() {
        const allPackages = this.state.allOfferDetails.map((item, key) => {
            try{
                var productPrice = {}
                try {
                    if (item.productOfferingPrice[0]) {
                        for (var i = 0; i < item.productOfferingPrice.length; i++) {
                            if(item.productOfferingPrice[i].priceCategory && item.productOfferingPrice[i].priceCategory && item.productOfferingPrice[i].priceCategory.id){
                                if (item.productOfferingPrice[i].priceCategory.id === "0") {
                                    productPrice = item.productOfferingPrice[i];
                                }
                            }
                        }
                    }
                } catch (err) {
                    console.log("error>>>",err)
                    productPrice = {}
                }


    // For discounts 
    var discountArray		= [];
    var taxArray = [];   
    var totalDiscountPrice = "0";
    var basePrice = 0;
    var baseCount = 1;
    for(var e = 0; e < item.productOfferingPrice.length; e++){
        var priceObject	= item.productOfferingPrice[e];


         //tier based price
         
          if(priceObject && priceObject.priceCategory && priceObject.priceCategory.id && priceObject.priceCategory.id === "0"){
            if(priceObject && priceObject.tierbased && priceObject.tierbased == true){
                for(var c=0; c< this.state.currentServiceList.length; c++){
                    if(item.id === this.state.currentServiceList[c]){
                        baseCount = baseCount + 1;
                    }
                }    

                for(var d=0; d< priceObject.tiers.length; d++){
                    var currentTempObj = priceObject.tiers[d];
                    if(baseCount >= currentTempObj.startRange && baseCount <= currentTempObj.endRange){
                        basePrice = currentTempObj.price;   
                        break;   
                    } else {
                        basePrice = priceObject.price;
                    }
                }
            } else {
                basePrice = priceObject.price;
            }
          }
        }

        var totalBaseTax = 0;
        for(var i = 0; i < item.productOfferingPrice.length; i++){
            var priceObject	= item.productOfferingPrice[i];

        if(priceObject.priceCategory && priceObject.priceCategory.id && priceObject.priceCategory.id == this.props.locales.priceCategoryForDiscount && !isNaN(parseFloat(priceObject.price))){

            var discountPrice = "0.00";
            if(priceObject && priceObject.priceType && priceObject.priceType.id && priceObject.priceType.id == this.props.locales.PriceTypeForPercentage){
                discountPrice = parseFloat((parseFloat(basePrice).toFixed(2) * (parseFloat(priceObject.price)).toFixed(2))/100).toFixed(2);
            } else{
                discountPrice = (parseFloat(priceObject.price)).toFixed(2);
            }
            
            totalDiscountPrice = parseFloat(totalDiscountPrice) + parseFloat(discountPrice);
            
            var discountObject = {
                "discountPrice": (parseFloat(priceObject.price)).toFixed(2),
                "discountName": priceObject.name,
                "priceMode": priceObject.priceMode.id
            };
            discountArray.push(discountObject);
        }
            
        var basePriceAfterDiscount  =  basePrice-totalDiscountPrice;
            	//For Tax 
                var baseTaxPrice = 0;
                if(priceObject && priceObject.priceCategory && priceObject.priceCategory.id && priceObject.priceCategory.id == this.props.locales.priceCategoryForTax && !isNaN(parseFloat(priceObject.price))){  
                    if(priceObject.priceType!=null && priceObject.priceType.id == this.props.locales.PriceTypeForPercentage){
                        baseTaxPrice = (parseFloat(basePriceAfterDiscount).toFixed(2) * (parseFloat(priceObject.price)).toFixed(2)/100).toFixed(2);
                        totalBaseTax += baseTaxPrice
                    }else{
                        baseTaxPrice = (parseFloat(priceObject.price)).toFixed(2);
                        totalBaseTax += baseTaxPrice
                    } 
                  
                    var taxObject= {
                        "taxPrice": baseTaxPrice,
                        "taxName": priceObject.name,
                        "priceType": priceObject.priceType.id,
                        "priceMode": priceObject.priceMode.id,
                        "tax": priceObject.price
                    };
                    taxArray.push(taxObject);  
                }
            }

          var totalBaseAmount = basePriceAfterDiscount + parseFloat(totalBaseTax)
          totalBaseAmount = parseFloat(totalBaseAmount).toFixed(2)

                var contextValue = ""
                try {
                    if (item.productOfferingPrice[0].rules[0].conditions[0]) {
                        for (var y = 0; y < item.productOfferingPrice[0].rules[0].conditions.length; y++) {
                            if (item.productOfferingPrice[0].rules[0].conditions[y].contextParam[0].name === "VideoFormat") {
                                contextValue = item.productOfferingPrice[0].rules[0].conditions[y].contextParam[0].value
                            }
                        }
    
                    }
                } catch (err) {
                    contextValue = ""
                }
    
                var poType = {}
                try {
                    if (item.productSpecifications[0]) {
                        poType = item.productSpecifications[0].type;
                    }
                } catch (err) {
                    poType = {}
                }
           
                var productSpecifications = {}
                try {
                    if (item.productSpecifications[0]) {
                        productSpecifications = item.productSpecifications[0];
                    }
                } catch (err) {
                    productSpecifications = {}
                }
    
                var productOfferGroup = {}
                try {
                    if (item.productOfferGroup) {
                        productOfferGroup = item.productOfferGroup;
                    }
                } catch (err) {
                    productOfferGroup = {}
                }

                var skipSom = "false";
                var cfss = []
                try {
                   for(var m = 0; m < item.productSpecifications.length; m++){
                       var currentPS = item.productSpecifications[m];
                       for(var n = 0; n< currentPS.cfss.length; n++){
                            var currentObjCfss = currentPS.cfss[n];
                            if(currentPS.releationships.length > 0){
                                for(var o = 0; o < currentPS.releationships.length; o++){
                                    var relationObj =  currentPS.releationships[0];
                                    if(relationObj && relationObj.targetObject && currentObjCfss.id === relationObj.targetObject.id){
                                        if(relationObj && relationObj.skipSOM && relationObj.skipSOM == "true"){
                                            skipSom = "true";
                                        }
                                    }
                                }
                            }
                            currentObjCfss["skip_som"] = skipSom
                            cfss.push(currentObjCfss)
                            delete currentObjCfss.validFor
                       }
                   }
                } catch (err) {
                    cfss = []
                }
           
                var cfssArray = []
                for (var x = 0; x < cfss.length; x++) {
                    let temp = {
                        "id": cfss[x].id,
                        "name": cfss[x].name,
                        "href": cfss[x].href,
                        "service_type": cfss[x].serviceType,
                        "service_class": cfss[x].serviceClass,
                        "transport_type": cfss[x].transportType,
                        "service_category": cfss[x].serviceCategory,
                        "characteristics": cfss[x].characteristics,
                        "skip_som": cfss[x].skip_som
                    }
                    cfssArray.push(temp);
                }

            
                var pogIdFromResponse = item.productOfferGroup.id;
                var allPogIds = [];
                var cfssEndDateInYears = "2";
                if(this.props.configurationValues){
                    allPogIds = this.props.configurationValues.allPog
                    cfssEndDateInYears = this.props.configurationValues.cfssEndDateInYears
                }
                var connectionTypeId = this.props.cache.currentPlanDetails.connectionType
                for(var t=0; t < allPogIds.length; t++){
                    if( allPogIds[t].name.toUpperCase() === "PREPAIDPLUS"){
                        if(allPogIds[t].id === pogIdFromResponse){
                            connectionTypeId = "3";
                        }
                    }
                }
                var connectionType = "POSTPAID"
                if(connectionTypeId === this.props.locales.connectionTypeForPrepaid)
                connectionType = "PREPAID"

                for(var y=0;y<cfssArray.length;y++){
                    if(cfssArray[y].characteristics){
                        var characteristics=cfssArray[y].characteristics;
                        for(var k=0;k<characteristics.length;k++){
                            if(characteristics[k].name){
                                if(characteristics[k].name === "CONNECTION_TYPE"){
                                    characteristics[k]["value"] = connectionType
                                }
                                if(characteristics[k].name === "START_DATE"){
                                    characteristics[k]["value"] =  moment().format("DD-MM-YYYY HH:mm:ss")
                                }
                                if(characteristics[k].name === "END_DATE"){
                                    characteristics[k]["value"] = moment().add(cfssEndDateInYears, 'years').format("DD-MM-YYYY HH:mm:ss")
                                }
                                if(characteristics[k].name === "NAME"){
                                    characteristics[k]["value"] = item.id
                                }
                            }
                        }
                    }
                }

                //APUA CHANGE
                //var connectionType= "POSTPAID";
                // for(var p=0;p<cfssArray.length;p++){
                //     if(cfssArray[p].characteristics){
                //         var characteristics=cfssArray[p].characteristics;
                //         for(var q=0;q<characteristics.length;q++){
                //             if(characteristics[q].name && characteristics[q].value){
                //                 if(characteristics[q].name=="CONNECTION_TYPE"){
                //                     connectionType = characteristics[q].value.toUpperCase()
                //                 }
                //             }
                //         }
                //     }
                // }

              

                var discountPrice = {}
                try {
                    if (item.productOfferingPrice[0]) {
                        for (var i = 0; i < item.productOfferingPrice.length; i++) {
                            if (item.productOfferingPrice[i].priceCategory.id == "4") {
                                discountPrice = item.productOfferingPrice[i];
                            }
                        }
                    }
                } catch (err) {
                    discountPrice = {}
                }
                var discountPercentage = 0
                if(discountPrice && discountPrice.price){
                    discountPercentage = parseFloat(discountPrice.price)*100/parseFloat(productPrice.price)
                    discountPercentage = Math.round(discountPercentage)
                }

                var subscriptionCharges = []
                var effective_date = moment().format("MM/DD/YYYY HH:mm:ss")
                var expiry_date = moment().add(103, 'years').format("MM/DD/YYYY HH:mm:ss")
                var ratingParam = item.ratingParameters[0]
                if(item.productOfferingPrice[0].priceMode.id == "1"){
                    if(ratingParam && ratingParam.subscriptionPeriod){
                        var subscriptionPeriod = parseInt(ratingParam.subscriptionPeriod)
                        if(ratingParam.subscriptionPeriodType.id == "0"){
                            expiry_date = moment(effective_date, "MM/DD/YYYY HH:mm:ss").add(subscriptionPeriod, 'days');
                        } else if(ratingParam.subscriptionPeriodType.id === "1"){
                            expiry_date = moment(effective_date, "MM/DD/YYYY HH:mm:ss").add(subscriptionPeriod, 'weeks');
                        } else if(ratingParam.subscriptionPeriodType.id === "2"){
                            expiry_date = moment(effective_date, "MM/DD/YYYY HH:mm:ss").add(subscriptionPeriod, 'months');
                        } else if(ratingParam.subscriptionPeriodType.id === "3"){
                            expiry_date = moment(effective_date, "MM/DD/YYYY HH:mm:ss").add(subscriptionPeriod, 'years');
                        } else if(ratingParam.subscriptionPeriodType.id === "4"){
                            expiry_date = moment(effective_date, "MM/DD/YYYY HH:mm:ss").add(subscriptionPeriod, 'hours');
                        }
                    }
                }
           
             expiry_date = moment(expiry_date).format("MM/DD/YYYY HH:mm:ss") 
                for (var k = 0; k < item.productOfferingPrice.length; k++) {
                    var prorata_flags = ""
                    try {
                        var prorataEnabledInSuspension = item.productOfferingPrice[k].prorataEnabledInSuspension ? "1" : "0";
                        var prorataEnabledInTermination = item.productOfferingPrice[k].prorataEnabledInTermination ? "1" : "0";
                        var prorataEnabledInPlanChange = item.productOfferingPrice[k].prorataEnabledInPlanChange ? "1" : "0";
                        var prorataEnabledInActivation = item.productOfferingPrice[k].prorataEnabledInActivation ? "1" : "0";
                        prorata_flags = prorataEnabledInActivation + prorataEnabledInTermination + prorataEnabledInSuspension + prorataEnabledInPlanChange
                    } catch (err) {
                        prorata_flags = ""
                    }
                    var factor = ""
                    if (item.productOfferingPrice[k].factor) {
                        factor = item.productOfferingPrice[k].factor
                    }
                    var frequency = ""
                    if (item.productOfferingPrice[k].frequency) {
                        frequency = item.productOfferingPrice[k].frequency.id
                    }
                    let tempCharges = {}
                    try {
                        tempCharges = {
                            "upc_charge_id": item.productOfferingPrice[k].id,
                            "charge_type": item.productOfferingPrice[k].priceMode.id,
                            "charge_name": item.productOfferingPrice[k].name,
                            "charge_desc": item.productOfferingPrice[k].description,
                            "charge_tax": "",
                            "discount_level": "",
                            "start_date": moment().format("MM/DD/YYYY HH:mm:ss"),
                            "end_date": expiry_date,
                            "charge_tax": item.productOfferingPrice[k].priceCode.taxCategoryId,
                            "charge_validity": "",
                            "charge_category": item.productOfferingPrice[k].priceCategory.billingChargeType.id,
                            "charge_category_upc": item.productOfferingPrice[k].priceCategory.id,
                            "charge_id": item.id,
                            "epc_enabled": "1",
                            "quantity_based": "",
                            "charge_classification": "",
                            "charge_amount_type": item.productOfferingPrice[k].priceType.name,
                            "charge_frequency": frequency,
                            "charge_factor": factor,
                            "is_prorata": item.productOfferingPrice[k].prorataEnable ? "1" : "0",
                            "prorata_flags": prorata_flags,
                            "charge_code": item.productOfferingPrice[k].priceCode.id,
                            "version" : item.productOfferingPrice[k].versionNo
                        }
                       
                        tempCharges["discount_level"] = "1";
                        if(item.productOfferingPrice[k].priceType.id === "0"){
                            tempCharges["discount_type"] = "F"
                        } else {
                            tempCharges["discount_type"] = "P"
                        }
                
                        if(connectionType === "POSTPAID"){
                            tempCharges["charge_amount"] = item.productOfferingPrice[k].price
                            tempCharges["total_charge"] = item.productOfferingPrice[k].price
                        } else {
                            tempCharges["charge_amount"] = "0"
                            tempCharges["total_charge"] = "0"
                        }
                    } catch (err) {
                        tempCharges = {}
                    }
                    if(Object.keys(tempCharges).length > 0 ){
                        subscriptionCharges.push(tempCharges)
                    }
                }

                var productFamilyIdFromResponse = item.productOfferGroup.productFamily.id
                var currentAddonDataTemp = {};
                currentAddonDataTemp["id"] = item["id"];
                currentAddonDataTemp["name"] = item["marketingDescription"];
                currentAddonDataTemp["description"] = item["description"];
                currentAddonDataTemp["offerAmount"] = basePrice;
                currentAddonDataTemp["effective_date"] = effective_date;
                currentAddonDataTemp["expiry_date"] = expiry_date;
                currentAddonDataTemp["discount"] = 0;
                currentAddonDataTemp["discountPrice"] = discountArray;
                currentAddonDataTemp["basePriceWithDiscount"] = totalBaseAmount;
                currentAddonDataTemp["productId"] = productOfferGroup.id;
                currentAddonDataTemp["productName"] = productOfferGroup.name;
                currentAddonDataTemp["poType"] = poType.id;
                currentAddonDataTemp["subscriptionCharges"] = subscriptionCharges;
                currentAddonDataTemp["contextValue"] = contextValue;
                currentAddonDataTemp["po_sub_type"] = "0";
                currentAddonDataTemp["discount"] = discountPrice.price || 0;
                currentAddonDataTemp["discountName"] = discountPrice.name || "NA";
                currentAddonDataTemp["pogIdFromResponse"] = pogIdFromResponse;
                currentAddonDataTemp["contractDetails"] = item.contracts;
                currentAddonDataTemp["productFamilyIdFromResponse"] = productFamilyIdFromResponse;
                currentAddonDataTemp["poTypeName"] = poType.name;
                currentAddonDataTemp["psVesrion"] = productSpecifications.versionNo;
                currentAddonDataTemp["psStatus"] = productSpecifications.versionStatus;
                currentAddonDataTemp["psId"] = productSpecifications.id;
                currentAddonDataTemp["psName"] = productSpecifications.name;
                currentAddonDataTemp["connectionType"] = connectionType
                currentAddonDataTemp["connectionTypeId"] = connectionTypeId;
                currentAddonDataTemp["discountArray"] = discountArray;
                currentAddonDataTemp["taxArray"] = taxArray;
                if (cfssArray.length > 0) {
                    currentAddonDataTemp["cfss"] = cfssArray;
                }
            }
                catch(err){
                    console.log("error>>>",err)
                    currentAddonDataTemp = {}
                }
               
                var currentPackageData = encodeURIComponent(JSON.stringify(currentAddonDataTemp))
               
                var isSelected = false;
                for (var i = 0; i < Object.keys(this.state.serviceDetails).length; i++) {
                    if (item["id"] == this.state.serviceDetails.id) { isSelected = true }
                }
                if(this.state.ignorePlanIds.includes(item.marketingDescription)) {}
                else if(this.state.currentPlanId !== item.id) {
                    return (
                        <div className="col-md-6 p-0" key={key}>
                            <div className={isSelected ? "packageDetailsContent align-items-center mb-3 row m-0" : "packageDetailsContentInactive align-items-center mb-3 row m-0"} onClick={() => { this.planSelectionButtonClicked(currentPackageData) }}>
                            <div className='col-md-12' style={{minHeight: 197}}>
                            <div className="col-md-12" style={{ height: 30 }}>
                            {isSelected ?
                                <div className="selectedBadge">
                                    {this.props.locales.selectedLabelAddons}
                                </div>
                                :
                                <div>
                                </div>
                            }
                            </div>
                            <div className="col-12 row p-0 px-2 m-0 pt-2 justify-content-between">
                            <div className="nameContainer col-9 p-0">{item.marketingDescription}</div>
                                <div className="col-3 row m-0 p-0 ">
                                    <div className="row p-0 m-0" style={{ color: '#231F20', fontWeight: 500}}>
                                        ${basePrice}
                                    </div>
                                    <div className="nameContainerDesc">(Base Price)</div>
                                </div>
                            </div>
                                <div className="col-md-12 nameContainerDesc" title= {item.description}>
                                    {item.description}
                                </div>

                                {discountArray.map((item, key) => {
                                return (
                                    <div className='col-12 d-flex justify-content-between align-items-center p-0 px-3 pt-2' key={key} style={{fontWeight: 600, color: '#FE9A2E'}}>
                                        <div>
                                            <div className="amountName">{item.discountName}</div>
                                        </div>
                                        <div>
                                            <div className="amountVal">${item.discountPrice}</div>
                                        </div>
                                    </div>
                                )
                            })
                        }
                        
                        {taxArray.map((item, key) => {
                                return (
                                    <div className='col-12 d-flex justify-content-between align-items-center p-0 px-3 pt-2' key={key} style={{fontWeight: 600}}>
                                        <div>
                                            <div className="amountName">{item.taxName}</div>
                                        </div>
                                        <div>
                                            <div className="amountVal">${item.taxPrice}</div>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>
                
                                {Object.keys(item.contracts).length > 0
                                ?
                              
                                <div className="col-12 row m-0 py-2">
                                    {item.contracts.map((optn,key) => {
                                        // var str = optn.name;
                                        // str = str.replace(" Contract", "");
                                        var optionselected = false;
                                        if(isSelected){
                                            for (var i = 0; i < Object.keys(this.state.selectedContract).length; i++) {
                                                if (optn["id"] == this.state.selectedContract.id) { optionselected = true }
                                            }
                                        }
                                    
                                        // if(key == 0 && Object.keys(this.state.selectedContract).length == 0){
                                        //     console.log("fggfgfgf")
                                        //     optionselected = true
                                        // }
                                        return (
                                        <div className="col-6 p-0 mb-1" onClick={(event) => { this.contractSelectButtonClicked(optn,event,currentPackageData) }}>
                                            <div className={optionselected ? "p-1 m-auto activeContractDiv" : "p-1 m-auto inactiveContractDiv"}>
                                                {optn.name}
                                            </div>
                                        </div>
                                        )
                                }) }
                                </div>
                                : null
                                }
                                
                            {/* {item.tariffArr.length > 0 ?
                                <div className="col-md-12 moreInfo" onClick={(event) => { this.serviceMoreInfoClicked(event,item.tariffArr,this.props.locales.tariffHeadingInModal) }}>
                                    View Tariff Details
                                </div>
                                : 
                                <div className="col-md-12 moreInfo" style={{visibility: 'hidden'}}>
                                    View Tariff Details
                                </div>
                                 }
                                {item.bucketDetailsArr.length > 0 ?
                                <div className="col-md-12 moreInfo pt-1" onClick={(event) => { this.serviceMoreInfoClicked(event,item.bucketDetailsArr,this.props.locales.bucketDetailsHeadingInModal) }}>
                                    View Bucket Details
                                </div>
                                : 
                                <div className="col-md-12 moreInfo" style={{visibility: 'hidden'}}>
                                    View Bucket Details
                                </div> 
                             } */}

                       
                        <div className='col-12 d-flex justify-content-end align-items-center totalPriceContainer'>
                            <div className='name px-3'>
                                Total
                            </div>
                            <div className='price'>
                                ${totalBaseAmount}
                            </div>
                        </div>
                        </div>  
                    </div>
                );
            }  
        });
        if (this.state.allOfferDetails.length > 0) {
            return (<div className="planDetailsContainer row col-md-12 p-0 mx-auto">{allPackages}</div>);
        } else {
            return (<div className="col-md-12 row mb-4 planDetailsContainer mr-4 p-0 mt-2"><div className="col-md-12"><NoDataFound content={this.props.locales.noPlansAvailablAlertForUpgradePlan} /></div></div>);
        }
    }
 
    updateWindowDimensions = () => {
        //this.setState({ windowWidth: window.innerWidth, windowHeight: window.innerHeight });
    }

    arrowButtonClicked(type){
        this.setState({isCartVisibleForMobile:type})
    }

    serviceMoreInfoClicked(event,receivedContent,heading){
        this.setState({isMoreInfoModalOpen: false})
        event.stopPropagation();
        this.setState({
            content : receivedContent,
            heading : heading,
            moreInfo_name: "",
            isMoreInfoModalOpen : true
        })
    }

    MoreInfoModalCancel(){
        this.setState({isMoreInfoModalOpen: false})
    }

    componentDidUpdate(prevProps) {
        if (this.props.registerDetails !== prevProps.registerDetails) {
            this.calculateTotalCharge();
        }
    }

    calculateTotalCharge() {
        let sum = 0;
        var currentObj = this.props.registerDetails.offers;
        for (var i = 0; i < this.props.registerDetails.customize.addons.length; i++) {
            sum = sum + (parseFloat(this.props.registerDetails.customize.addons[i].offerAmount || 0) * this.props.registerDetails.customize.addons[i].count)
        }

        sum = parseFloat(this.props.registerDetails.offers.offerAmount)

        if(currentObj && currentObj.taxArray){
            for(var k=0; k < currentObj.taxArray.length; k++){
                sum = sum + parseFloat(currentObj.taxArray[k].taxPrice)
            }
        }
      
        if(currentObj && currentObj.discountArray){
            for(var j=0; j < currentObj.discountArray.length; j++){
                sum = sum - parseFloat(currentObj.discountArray[j].discountPrice)
            }
        }
        
        this.state.currentOfferCharge = parseFloat(this.props.registerDetails.offers.offerAmount);
        if(this.props.cache.currentPlanDetails.isContractExpired == false){
            sum = sum + parseFloat(this.props.registerDetails.contractDetails.price)
        } 

        this.state.totalMonthlyCharges = sum;
       
        this.setState({ dummy: "dummy" });
    }

    cartNextButtonClicked(){
        window.scroll({ top: 0, left: 0, behavior: 'smooth' });
        this.props.setCurrentPage("pageName", "planComparison");
    }


    render() {
        if (this.state.redirectToMyAccount) {
            return (
                <MyAccountComponent feature={this.state.feature} />
            )
        }

        return (
            <div id="customizePartTopDivContainer">
                 {this.state.isLoading ? <LoadingAnimation isVisible={true} /> : this.componentContent()}
            </div>
        );
    }

    componentContent() {
        if(this.state.isCartVisibleForMobile == false){
            const customizeComponentStyle = { minHeight: this.state.windowHeight + 'px' ,width:'92%'};
        return (
            <div className="mb-5">
            <div className="col-md-12 p-0 ml-auto" id="changePlanServicesMainContainer" style={customizeComponentStyle}>
                <div className="d-flex justify-content-between p-0 mt-5 mb-4 pt-sm-0 pt-4">
                    <div className="text-left">
                        <div className="" style={{color: '#33495F' ,fontSize:24,fontWeight:500}}>{this.props.locales.servicesTextForTabLinkManageService}</div>
                        <div className="d-flex" style={{ color: '#33495F' }}>
                            <div className="" style={{ cursor: 'pointer', fontSize: 18 }} onClick={() => this.tabLinkClicked('myAccount')}>{this.props.locales.myAccountTextInTabLinkManageService} &nbsp;&nbsp;></div>
                            <div className="ml-3" style={{ cursor: 'pointer', fontSize: 18,fontWeight:500 }} onClick={() => this.tabLinkClicked('manageService')}>{this.props.locales.manageServiceTextInTabLinkManageService}</div>
                        </div>
                    </div>
                </div>
                <div className="col-md-12 row changePlanCustomizePart m-0 p-0">
                    <div className="col-md-8 pb-4 p-0 pr-3">
                        <div className="col-md-12 p-0">
                            <div className="col-md-12 p-0 pr-3"><div className="col-md-12 pb-2 p-0 mb-4" style={{color:'#33495F',fontSize:18,fontWeight:500,borderBottom:'1px solid #D6D6D6'}}>{this.props.locales.chooseOfferHeadingUpgradeOffer}</div></div>
                            <div className="col-md-12 pb-4 pr-0 p-0">
                                <div className="addonDetailsContainer col-md-12 p-0 m-0">
                                    <div className="col-md-12 row p-0 m-0">{this.populateAllOffers()}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4 pb-4 d-none d-sm-block">
                        <PlanCartComponent/>
                    </div>
                    {/* <ModalComponent 
                        isVisible = {this.state.isMoreInfoModalOpen}
                        content = {this.state.content}
                        heading = {this.state.heading}
                        callback={this.moreInfoModalHandler}
                    /> */}

                <SliderModal
                    isVisible={this.state.isMoreInfoModalOpen}
                    uniqueModalReferenceId="moreInfoPart"
                    mainHeading={this.state.heading}
                    isResetButtonVisible={false}
                    leftPartFlexValue={1.5}
                    rightPartFlexValue={1}
                    contentPartBackgroundColor="#F5F8FB"
                    isSubmitButtonVisible={false}
                    isValidationRequired = {false}
                    callback={this.moreInfoModalHandler}
                >
                     <div className="col-md-12">
                        <div className="col-md-12 px-2">
                            <div className="col-md-12 py-3 p-0" id="phoneMumPart">
                                <div className="form-group col-md-12 p-0 mb-1">
                                    <label className="formGroup_label">Search</label>
                                    <div className="input-group">
                                        <input type="text" className="form-control formGroup_value mandatoryFieldWithoutStyle input_data typeNumber"
                                            name="moreInfo_name" autoComplete="off" value={this.state.moreInfo_name} style={{border: '1px solid #EAEDF0',borderRadius:4}}
                                            onChange={(event) => {
                                                this.handleInputValueChange("moreInfo_name", event.target.value)
                                            }}
                                        />
                                        <div className="input-group-append">
                                            <span className="input-group-text" style={{ backgroundColor: '#ffffff', borderLeft: 0, color: '#d6d6d6' }}>
                                                    {/* <img src={searchIcon} alt="" />  */}
                                            </span>
                                        </div>
                                    </div>
                                    <div className="errorDesc"></div>
                                </div>
                            </div>
                          
                        {this.state.content
                                .filter(item => {
                                    if (!this.state.moreInfo_name) return true;
                                    if (item.name.toLocaleLowerCase().includes(this.state.moreInfo_name.toLocaleLowerCase())) {
                                        return true;
                                    }
                                    return false;
                                })
                                .map((item, key) => {
                                    return(
                                        <div className="col-md-12 row p-0 pb-2 popupContent mx-auto px-1" key={key}>
                                            <div className="col-md-1 p-0">{key+1}</div>
                                            <div className="col-md-11 p-0">{item.name}</div>
                                        </div>
                                    )
                                })
                       }

                        </div>
                    </div>
                </SliderModal>

                </div>
                {Object.keys(this.props.registerDetails.offers).length > 0 ?
                <div className="d-block d-md-none bottomCartPartForMobile" style={{bottom:0}}>
                    <div className="d-flex flex-column">
                        <div className="d-flex justify-content-center pt-2"><img src={PathIcon} alt="" onClick={() => { this.arrowButtonClicked(true) }}/></div>
                        <div className="d-flex align-items-center justify-content-between px-3 pb-1">
                            <div className="amountContainer">
                                    <div>{this.props.locales.amountToPayForMobViewAllAddons}</div>
                                    <div style={{fontSize: 28}}>{Constants.dollarSign}{GeneralUtils.formatNumberToStandardForm(this.state.totalMonthlyCharges)}</div>
                            </div>
                            <div>
                            <Button className="nextButton" onClick={() => { this.cartNextButtonClicked() }}>
                                {this.props.locales.nextBtnTxtMobViewAllAddonsComponent}
                            </Button>
                            </div>
                        </div>
                    </div>
                </div>
                : null }
                </div>
            </div>
        );
        } else {
            const customizeComponentStyle = { minHeight: this.state.windowHeight + 'px' ,width:'100%', marginTop: '110px'};
            return(
            <div className="mb-5 mx-4 col-12 mx-auto">
            <div className="col-12 p-0" style={customizeComponentStyle}>
                <div className="col-12  pb-4 m-0 mx-auto px-0">
                    <PlanCartComponent/>
                </div>
            </div>
            {Object.keys(this.props.registerDetails.offers).length > 0 ?
                <div className="d-block d-md-none bottomCartPartForMobile" style={{top:0}}>
                <div className="d-flex flex-column">
                    <div className="d-flex align-items-center justify-content-between px-3 pt-1">
                        <div className="amountContainer">
                                <div>{this.props.locales.amountToPayForMobViewAllAddons}</div>
                                <div style={{fontSize: 28}}>{Constants.dollarSign}{GeneralUtils.formatNumberToStandardForm(this.state.totalMonthlyCharges)}</div>
                        </div>
                        <div>
                        <Button className="nextButton" onClick={() => { this.cartNextButtonClicked() }}>
                            {this.props.locales.nextBtnTxtMobViewAllAddonsComponent}
                        </Button>
                        </div>
                    </div>
                    <div className="d-flex justify-content-center pb-2"><img className="rotate180" src={PathIcon} alt="" onClick={() => { this.arrowButtonClicked(false) }} /></div>
                </div>
            </div>
        : null }

            </div>
        );
        }
    }
}

const mapStateToProps = (state, ownProperties) => {
    return {
        locales: state.locales,
        registerDetails: state.registerDetails,
        currentPage: state.currentPage,
        feasibilityResposnse: state.feasibilityResposnse,
        contextParameters: state.contextParameters,
        cache: state.cache,
        userDetails: state.userDetails,
        configurationValues: state.configurationValues
    }
}

function mapDispatchToProps(dispatch) {
    return {
        setRegisterDetails: function (key, payload) {
            dispatch(setRegisterDetails(key, payload));
        },
        setCurrentPage: function (key, payload) {
            dispatch(setCurrentPage(key, payload));
        },
        setOrderDetails: function (key, payload) {
            dispatch(setOrderDetails(key, payload));
        }
    }
}

const UpgradeOfferComponentContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(UpgradeOfferComponent)

export default UpgradeOfferComponentContainer;

